export const lensAddresses = {
  accountLens: "0x41FE40e10268decF2D25c60aDf60469EE94E8771",
  eulerEarnVaultLens: "0x884aA1bcDc75916B50f3A5268998598C63dC6936",
  irmLens: "0x0e367C8a8ffBF4555f1B4bC1fA99CA97c253Fe33",
  oracleLens: "0x428a144214D3E640634491F05b7130ba26A394f3",
  utilsLens: "0xb05668273c66944CCc5ca69466D27a63CCCfE623",
  vaultLens: "0xC6B56a52e5823659d90F3020164b92D1c2de03CE",
} as const
